export const HOST = process.env.REACT_APP_API_URL || 'https://cdn-dev.kiemdinhoto.vn'
export const IMAGE_HOST = HOST + 'upload/'